
import myData from './AppConfig.json';
import AppView from './AppView';

const MyApp = () => {
  return <AppView data={myData as any} />;
}

export default MyApp
